import { Timer } from "./Timer";
/**
 * A task which will be executed after a given delay.
 */
var DelayedTask = /** @class */ (function () {
    function DelayedTask(pTask) {
        var _this = this;
        this.onTimeout = function () {
            var tResolve = _this.mPromiseResolve;
            var tReject = _this.mPromiseReject;
            _this.mPromise = null;
            _this.mPromiseResolve = null;
            _this.mPromiseReject = null;
            if (tResolve != null && tReject != null) {
                _this.mTask().then(tResolve).catch(tReject);
            }
        };
        this.mTask = pTask;
        this.mTimer = new Timer(this.onTimeout);
    }
    /**
     * Starts the execution of the task. The task will be executed only once if consecutive
     * calls are made during the delay.
     * @param pDelay Delay in milliseconds before the task gets executed.
     * @param pRestartTimer If true and the delay timer is currently running, the timer will be
     * restartet with the new delay. If false the currently running timer will
     * stay active and the new delay is ignored. (default: false)
     */
    DelayedTask.prototype.run = function (pDelay, pRestartTimer) {
        var _this = this;
        if (pRestartTimer === void 0) { pRestartTimer = false; }
        if (this.mPromise == null) {
            this.mPromise = new Promise(function (resolve, reject) {
                _this.mPromiseResolve = resolve;
                _this.mPromiseReject = reject;
            });
        }
        this.mTimer.start(pDelay, pRestartTimer);
        return (this.mPromise);
    };
    return DelayedTask;
}());
export { DelayedTask };
export default DelayedTask;
